import Box from "@memorang/ui/components/Box";
import { Button } from "react-native-paper";
import usePodcastPlayer from "../hooks/usePodcastPlayer";
import { useSavedPodcasts } from "../hooks/useSavedPodcasts";

type Props = {
	visible?: boolean;
};

export const PlaySavedPodcastsButton = ({ visible = true }: Props) => {
	const { savedPodcasts } = useSavedPodcasts();
	const { playCustomPodcasts } = usePodcastPlayer();

	if (!visible || savedPodcasts.length === 0) {
		return null;
	}

	const handlePlayAllSaved = () => {
		if (savedPodcasts.length > 0) {
			playCustomPodcasts(
				savedPodcasts[0].id,
				savedPodcasts.map((p) => p.id),
			);
		}
	};

	return (
		<Box paddingVertical={8}>
			<Button
				mode="contained"
				icon="play"
				onPress={handlePlayAllSaved}
				style={{ borderRadius: 8 }}
			>
				Play All Saved
			</Button>
		</Box>
	);
};
